import { dateTimeDefault, messageType, sendMethodEnum } from 'consts/data';
import { setTimeOfDateToDefault } from 'helpers/date-time';
import { parseDomainObjToString } from 'helpers/domain';
import { cloneDeep, isArray, isPlainObject } from 'lodash';

class ResponderModel {
  static isVoice(msgType) {
    return [messageType.RVM, messageType.ringlessVoicemail, messageType.voice].includes(msgType);
  }

  static isMMS(msgType) {
    return [messageType.mms].includes(msgType);
  }

  static parseBodyToSaveNode(payload = {}, { isClone, isNew } = {}) {
    const {
      impressionUrl,
      sendMethod,
      parentId,

      idResponder,
      id,
      userId,
      dialogId,
      triggerCount,
      created,

      deliveredCgId,
      replierCgId,
      clickerCgId,
      convertorCgId,
      listenerCgId,
      callbackCgId,

      messageType,
      media,
      routeId,
    } = payload;

    const isUpdate = !isClone && !isNew;
    const isMMS = ResponderModel.isMMS(messageType);
    const isVoice = ResponderModel.isVoice(messageType);

    //* Parse data to PUT/POST
    // New update: creatives and offers in responder
    let { creatives, creativeOnFly, ani, intent, keyword, triggerType } = payload;

    const isOneWay = sendMethod === sendMethodEnum.oneWay;

    //* Handle when oneWay
    ani = isOneWay ? ani : '';
    intent = isOneWay ? '' : intent;
    keyword = isOneWay ? '' : keyword;

    // if (!!triggerType && isObject(triggerType)) {
    //   triggerType.reply = isOneWay ? false : triggerType?.reply || false;
    // }

    /** Process In Each On-fly creative */
    //* Merge offersOnFly -> offers in creativeOnFly
    if (creativeOnFly) {
      creativeOnFly = creativeOnFly
        .map((ele) => {
          ele.offers = ele.offers.map((offer) => ({
            offerId: offer.id,
            url: offer.url,
            domain: parseDomainObjToString(offer.domain),
          }));

          if (ele.offerOnFly) {
            ele.offers = [...ele.offers, ...ele.offerOnFly.map((o) => ({ ...o, offerId: null }))];
          }

          return ele;
        })
        .map((ele) => ({
          id: null,
          creativeId: null,
          message: ele.message,
          offers: ele.offers,
          delayedTime: ele.delayedTime,
          creativeMedia: ele?.creativeMedia,
        }));

      //* concat creativeOnFly -> creatives original
      creatives = [...creatives, ...creativeOnFly];
    }

    //* process offers in creatives
    creatives = creatives.map((creative) => {
      const tempObj = cloneDeep(creative);
      if (tempObj.offerOnFly) {
        tempObj.offers = [
          ...tempObj.offers,
          ...tempObj.offerOnFly.map((ele) => ({
            offerId: null,
            url: ele.url,
            domain: parseDomainObjToString(ele.domain),
          })),
        ];
      }

      if (isArray(tempObj.creativeMedia)) {
        tempObj.creativeMedia = tempObj.creativeMedia.map((el) => ({
          id: isClone ? null : el?.isFixed ? el.id : null,
          mediaId: el?.value,
          name: el?.label,
          duration: el?.duration,
        }));
      }

      if (!isMMS) {
        tempObj.creativeMedia = [];
      }

      delete tempObj.offerOnFly;
      return tempObj;
    });

    const body = {
      parentId: parentId ?? Number(idResponder),
      keyword,
      intent,
      dialogId: isNew || isClone ? Number(idResponder) : dialogId,
      creatives,
      ani,
      impressionUrl: (impressionUrl && impressionUrl.trim()) || '',
      triggerType,
      deliveredCgId: deliveredCgId || '',
      replierCgId: replierCgId || '',
      clickerCgId: clickerCgId || '',
      convertorCgId: convertorCgId || '',
      listenerCgId: listenerCgId || '',
      callbackCgId: callbackCgId || '',

      messageType,
      media,
      routeId: isPlainObject(routeId) ? routeId?.value : routeId,
    };

    if (isVoice) {
      body.media = body.media.map((el) => {
        if (el.isFixed) {
          return { ...el, id: isClone ? null : el.id, dialogId: body.dialogId };
        }

        return {
          id: null,
          dialogId: body.dialogId,
          mediaId: el?.value,
          name: el?.name,
          duration: el?.duration,
          delayedTime: el?.delayedTime,
        };
      });

      body.creatives = [];
    } else {
      body.media = [];
    }

    if (isUpdate) {
      body.id = id;
      body.userId = userId;
      body.triggerCount = triggerCount;
      body.created = created;
    }

    return body;
  }

  static parseBodyToSaveResponderDetail(values) {
    const nextBody = cloneDeep(values);

    delete nextBody.type;

    return nextBody;
  }
}

export class RespoderStatsModel {
  constructor(values) {
    this.datetime = values?.datetime;
    this.sent = values?.sent;
    this.clicked = values?.clicked;
    this.convertor = values?.convertor;
    this.cost = values?.cost;
    this.revenue = values?.revenue;
  }

  static filtersChart = (values) => {
    return {
      dialogId: values?.dialogId,
      dateRanges: {
        from: values?.to || setTimeOfDateToDefault(dateTimeDefault().before7Days()),
        to: values?.from || setTimeOfDateToDefault(dateTimeDefault().today(), true),
      },
    };
  };
}

export default ResponderModel;
